// App adapter over the dashboard's one analytics instance (createAnalytics from
// @rdrive/helper-analytics, built by createDashboard from dashboard.config.js's `analytics` —
// IA_ABSORPTION_PLAN Phase 3 step 8). Replaces the Vuex `analytics` module this used to dispatch
// to, with the same signatures: `trackEvent(eventName, params?, userEmail?)` and
// `trackPage(pageUrl, userEmail?)`. Call sites: App/setup.js, composables/useAppContext.js (the
// pages' `trackEvent`), and composables/useIssuesGrid.js, which hands `trackEvent` to
// composables/useIssuesGridReport.js (the report's `downloadReport` event).
// Call it where useDashboard() works: in a component's setup.
import { useDashboard } from '@rdrive/plugin-dashboard-shell';

export function useAnalytics() {
  const { analytics } = useDashboard();
  return { trackEvent: analytics.trackEvent, trackPage: analytics.trackPage };
}
